// extracted by mini-css-extract-plugin
module.exports = {"button":"_81a7b97","right":"_83c56b2"};